import { render, staticRenderFns } from "./NewCampaignPopup.vue?vue&type=template&id=020b5b44&scoped=true"
import script from "./NewCampaignPopup.vue?vue&type=script&lang=js"
export * from "./NewCampaignPopup.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/mkt-cms.css?vue&type=style&index=0&id=020b5b44&prod&scoped=true&lang=css&external"
import style1 from "./NewCampaignPopup.vue?vue&type=style&index=1&id=020b5b44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020b5b44",
  null
  
)

export default component.exports